import { useQuery } from "@tanstack/react-query";
import { api } from "../config";

export const getInvoiceSchedules = async (orderId: number | string | null | undefined, showAll: boolean) => {
    if (!orderId) return [];

    const filter = showAll
        ? { order: { _eq: orderId } }
        : { order: { _eq: orderId }, status: { _eq: "scheduled" } };

    const response = await api({
        method: "GET",
        url: "/items/scheduled_invoices",
        params: {
            fields: "*.*,scheduled_invoices_items.service.*,order.order_date",
            filter: JSON.stringify(filter),
            sort: "scheduled_date",
        },
    });

    return response.data.data;
};

export const useInvoiceSchedules = (orderId: number | string | null | undefined, showAll: boolean = false) => {
    return useQuery({
        queryKey: ["scheduled-invoices", orderId, showAll],
        queryFn: () => getInvoiceSchedules(orderId, showAll),
        enabled: !!orderId,
    });
};

